module.exports = require("./moment.js");


//////////////////
// WEBPACK FOOTER
// moment (bower component)
// module id = 1250
// module chunks = 1